/**
 * Video intercoms migrated from tools/camera-additions.json. Hikvision
 * DS-KH (indoor) + DS-KB / DS-KD (outdoor) + Dahua VTH (indoor) + VTO (outdoor).
 *
 * AUTO-GENERATED by tools/generate-migrated-catalogs.py from agent research
 * outputs in tools/equipment-research/. DO NOT edit by hand — re-run the
 * script if specs change. Generated on 2026-05-19.
 */
import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

export const MIGRATED_INTERCOMS: EquipmentCatalogEntry[] = [
  {
    id: 'dahua-vto4202f-p-s2',
    manufacturer: 'Dahua',
    model: 'VTO4202F-P-S2',
    category: 'intercom',
    tagline: 'VTO4202F-P-S2 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-p-s3',
    manufacturer: 'Dahua',
    model: 'VTO4202F-P-S3',
    category: 'intercom',
    tagline: 'VTO4202F-P-S3 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-p1',
    manufacturer: 'Dahua',
    model: 'VTO4202F-P1',
    category: 'intercom',
    tagline: 'VTO4202F-P1 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mb1',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MB1',
    category: 'intercom',
    tagline: 'VTO4202F-MB1 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mf',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MF',
    category: 'intercom',
    tagline: 'VTO4202F-MF — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mdb2',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MDB2',
    category: 'intercom',
    tagline: 'VTO4202F-MDB2 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-pi1',
    manufacturer: 'Dahua',
    model: 'VTO4202F-PI1',
    category: 'intercom',
    tagline: 'VTO4202F-PI1 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mb2',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MB2',
    category: 'intercom',
    tagline: 'VTO4202F-MB2 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mdb4',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MDB4',
    category: 'intercom',
    tagline: 'VTO4202F-MDB4 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mdb10',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MDB10',
    category: 'intercom',
    tagline: 'VTO4202F-MDB10 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mb5',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MB5',
    category: 'intercom',
    tagline: 'VTO4202F-MB5 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mi',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MI',
    category: 'intercom',
    tagline: 'VTO4202F-MI — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-x-series',
    manufacturer: 'Dahua',
    model: 'VTO4202F-X-SERIES',
    category: 'intercom',
    tagline: 'VTO4202F-X-SERIES — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mx-series',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MX-SERIES',
    category: 'intercom',
    tagline: 'VTO4202F-MX-SERIES — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202f-mk',
    manufacturer: 'Dahua',
    model: 'VTO4202F-MK',
    category: 'intercom',
    tagline: 'VTO4202F-MK — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Pro-Series/VTO4202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mb2',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MB2',
    category: 'intercom',
    tagline: 'VTO4103F-MB2 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mdb2',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MDB2',
    category: 'intercom',
    tagline: 'VTO4103F-MDB2 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-i1',
    manufacturer: 'Dahua',
    model: 'VTO4103F-I1',
    category: 'intercom',
    tagline: 'VTO4103F-I1 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mdb10',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MDB10',
    category: 'intercom',
    tagline: 'VTO4103F-MDB10 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-1',
    manufacturer: 'Dahua',
    model: 'VTO4103F-1',
    category: 'intercom',
    tagline: 'VTO4103F-1 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mf',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MF',
    category: 'intercom',
    tagline: 'VTO4103F-MF — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mk',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MK',
    category: 'intercom',
    tagline: 'VTO4103F-MK — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mi',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MI',
    category: 'intercom',
    tagline: 'VTO4103F-MI — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mb5',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MB5',
    category: 'intercom',
    tagline: 'VTO4103F-MB5 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mdb4',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MDB4',
    category: 'intercom',
    tagline: 'VTO4103F-MDB4 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103f-mb1',
    manufacturer: 'Dahua',
    model: 'VTO4103F-MB1',
    category: 'intercom',
    tagline: 'VTO4103F-MB1 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103F-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mb5',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MB5',
    category: 'intercom',
    tagline: 'VTO4103FB-MB5 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mk',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MK',
    category: 'intercom',
    tagline: 'VTO4103FB-MK — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mi',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MI',
    category: 'intercom',
    tagline: 'VTO4103FB-MI — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mdb10',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MDB10',
    category: 'intercom',
    tagline: 'VTO4103FB-MDB10 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mf',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MF',
    category: 'intercom',
    tagline: 'VTO4103FB-MF — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-ml',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-ML',
    category: 'intercom',
    tagline: 'VTO4103FB-ML — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mdb2',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MDB2',
    category: 'intercom',
    tagline: 'VTO4103FB-MDB2 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mb2',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MB2',
    category: 'intercom',
    tagline: 'VTO4103FB-MB2 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mdb4',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MDB4',
    category: 'intercom',
    tagline: 'VTO4103FB-MDB4 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-mb1',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-MB1',
    category: 'intercom',
    tagline: 'VTO4103FB-MB1 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4103fb-1',
    manufacturer: 'Dahua',
    model: 'VTO4103FB-1',
    category: 'intercom',
    tagline: 'VTO4103FB-1 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Apartment-Door-Station/Pro-Series/VTO4103FB-MB2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 2,
      ipRating: 'IP65',
      poe: false,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202fb-p-s3',
    manufacturer: 'Dahua',
    model: 'VTO4202FB-P-S3',
    category: 'intercom',
    tagline: 'VTO4202FB-P-S3 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO4202FB-P-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202fb-p1',
    manufacturer: 'Dahua',
    model: 'VTO4202FB-P1',
    category: 'intercom',
    tagline: 'VTO4202FB-P1 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO4202FB-P-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202fb-x-series',
    manufacturer: 'Dahua',
    model: 'VTO4202FB-X-SERIES',
    category: 'intercom',
    tagline: 'VTO4202FB-X-SERIES — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO4202FB-P-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202fb-mdb2',
    manufacturer: 'Dahua',
    model: 'VTO4202FB-MDB2',
    category: 'intercom',
    tagline: 'VTO4202FB-MDB2 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO4202FB-P-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202fb-mk',
    manufacturer: 'Dahua',
    model: 'VTO4202FB-MK',
    category: 'intercom',
    tagline: 'VTO4202FB-MK — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO4202FB-P-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202fb-mdb10',
    manufacturer: 'Dahua',
    model: 'VTO4202FB-MDB10',
    category: 'intercom',
    tagline: 'VTO4202FB-MDB10 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO4202FB-P-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202fb-mdb4',
    manufacturer: 'Dahua',
    model: 'VTO4202FB-MDB4',
    category: 'intercom',
    tagline: 'VTO4202FB-MDB4 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO4202FB-P-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto4202fb-mx-series',
    manufacturer: 'Dahua',
    model: 'VTO4202FB-MX-SERIES',
    category: 'intercom',
    tagline: 'VTO4202FB-MX-SERIES — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO4202FB-P-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto2111d-wp-s1',
    manufacturer: 'Dahua',
    model: 'VTO2111D-WP-S1',
    category: 'intercom',
    tagline: 'VTO2111D-WP-S1 — outdoor IP intercom station, 1.3 MP, IP65',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Products/Door-Stations/VTO2111D-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 1.3,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto2111d-p-s2',
    manufacturer: 'Dahua',
    model: 'VTO2111D-P-S2',
    category: 'intercom',
    tagline: 'VTO2111D-P-S2 — outdoor IP intercom station, 1.3 MP, IP65',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Products/Door-Stations/VTO2111D-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 1.3,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto9541d-s2',
    manufacturer: 'Dahua',
    model: 'VTO9541D-S2',
    category: 'intercom',
    tagline: 'VTO9541D-S2 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Ultra-Series/VTO9541D-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      monitorInches: 10.1,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto9541d-s3',
    manufacturer: 'Dahua',
    model: 'VTO9541D-S3',
    category: 'intercom',
    tagline: 'VTO9541D-S3 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Ultra-Series/VTO9541D-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      monitorInches: 10.1,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto7541g-s2',
    manufacturer: 'Dahua',
    model: 'VTO7541G-S2',
    category: 'intercom',
    tagline: 'VTO7541G-S2 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Ultra-Series/VTO7541G-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      monitorInches: 8,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto7541g-s3',
    manufacturer: 'Dahua',
    model: 'VTO7541G-S3',
    category: 'intercom',
    tagline: 'VTO7541G-S3 — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/IP-Series/Apartment-Door-Station/Ultra-Series/VTO7541G-S3',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      monitorInches: 8,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto2202f-p-s2',
    manufacturer: 'Dahua',
    model: 'VTO2202F-P-S2',
    category: 'intercom',
    tagline: 'VTO2202F-P-S2 — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Video-Intercoms/VTO2202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto2202f-p',
    manufacturer: 'Dahua',
    model: 'VTO2202F-P',
    category: 'intercom',
    tagline: 'VTO2202F-P — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Video-Intercoms/VTO2202F-P-S2',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto2101e-p-s1',
    manufacturer: 'Dahua',
    model: 'VTO2101E-P-S1',
    category: 'intercom',
    tagline: 'VTO2101E-P-S1 — outdoor IP intercom station, 1.3 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/id/products/All-Products/Discontinued-Products/Video-Intercoms/VTO2101E-P',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 1.3,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto2101e-p',
    manufacturer: 'Dahua',
    model: 'VTO2101E-P',
    category: 'intercom',
    tagline: 'VTO2101E-P — outdoor IP intercom station, 1.3 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/id/products/All-Products/Discontinued-Products/Video-Intercoms/VTO2101E-P',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 1.3,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vth2421fb-w-p',
    manufacturer: 'Dahua',
    model: 'VTH2421FB(W)-P',
    category: 'intercom',
    tagline: 'VTH2421FB(W)-P — indoor IP monitor, 7"',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Products/Indoor-Monitors/VTH2421FB(W)-P',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 7,
      poe: true,
    },
  },
  {
    id: 'dahua-vth2421fb-w-p-0a',
    manufacturer: 'Dahua',
    model: 'VTH2421FB(W)-P%0A',
    category: 'intercom',
    tagline: 'VTH2421FB(W)-P%0A — indoor IP monitor, 7"',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Products/Indoor-Monitors/VTH2421FB(W)-P',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 7,
      poe: true,
    },
  },
  {
    id: 'dahua-vth2621g-w-p',
    manufacturer: 'Dahua',
    model: 'VTH2621G(W)-P',
    category: 'intercom',
    tagline: 'VTH2621G(W)-P — indoor IP monitor, 7"',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Indoor-Monitor/Lite-Series/VTH2621G(W)-P',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 7,
      poe: true,
    },
  },
  {
    id: 'dahua-vth2621g-w-wp',
    manufacturer: 'Dahua',
    model: 'VTH2621G(W)-WP',
    category: 'intercom',
    tagline: 'VTH2621G(W)-WP — indoor IP monitor, 7"',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Indoor-Monitor/Lite-Series/VTH2621G(W)-P',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 7,
      poe: true,
    },
  },
  {
    id: 'dahua-vth8a21kms-cw',
    manufacturer: 'Dahua',
    model: 'VTH8A21KMS-CW',
    category: 'intercom',
    tagline: 'VTH8A21KMS-CW — indoor IP monitor, 10.1"',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Indoor-Monitor/Ultra-Series/VTH8A21KMS-W',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 10.1,
      poe: true,
    },
  },
  {
    id: 'dahua-vth8a21kms-w',
    manufacturer: 'Dahua',
    model: 'VTH8A21KMS-W',
    category: 'intercom',
    tagline: 'VTH8A21KMS-W — indoor IP monitor, 10.1"',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Indoor-Monitor/Ultra-Series/VTH8A21KMS-W',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 10.1,
      poe: true,
    },
  },
  {
    id: 'dahua-vth5744a-wp-f',
    manufacturer: 'Dahua',
    model: 'VTH5744A-WP-F',
    category: 'intercom',
    tagline: 'VTH5744A-WP-F — indoor IP monitor, 10.1"',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/vi/products/All-Products/Video-Intercoms/IP-Series/Indoor-Monitor/Pro-Series/VTH5744A-WP-F',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 10.1,
      poe: true,
    },
  },
  {
    id: 'dahua-vth5341g-w',
    manufacturer: 'Dahua',
    model: 'VTH5341G-W',
    category: 'intercom',
    tagline: 'VTH5341G-W — indoor IP monitor, 10"',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Products/Indoor-Monitors/VTH5341G-W',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 10,
      poe: true,
    },
  },
  {
    id: 'dahua-vth5113h-w',
    manufacturer: 'Dahua',
    model: 'VTH5113H-W',
    category: 'intercom',
    tagline: 'VTH5113H-W — indoor IP monitor, 7"',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/Products/All-Products/Video-Intercoms/2-Wire-Hybrid/Indoor-Monitor/Pro-Series/VTH5113H-W',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 7,
      poe: false,
    },
  },
  {
    id: 'dahua-vth5123h-w',
    manufacturer: 'Dahua',
    model: 'VTH5123H-W',
    category: 'intercom',
    tagline: 'VTH5123H-W — indoor IP monitor, 7"',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/2-Wire-Hybrid/Indoor-Monitor/Pro-Series/VTH5123H-W',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      monitorInches: 7,
      poe: false,
    },
  },
  {
    id: 'dahua-vto2311r-wp',
    manufacturer: 'Dahua',
    model: 'VTO2311R-WP',
    category: 'intercom',
    tagline: 'VTO2311R-WP — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Video-Intercoms/IP-Series/Villa-Door-Station/Pro-Series/VTO2311R-WP',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto3221e-p',
    manufacturer: 'Dahua',
    model: 'VTO3221E-P',
    category: 'intercom',
    tagline: 'VTO3221E-P — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Products/Door-Stations/VTO3221E-P',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto6222e-p',
    manufacturer: 'Dahua',
    model: 'VTO6222E-P',
    category: 'intercom',
    tagline: 'VTO6222E-P — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/2-Wire-IP/Apartment-Door-Station/Pro-Series/VTO6222E-P',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'dahua-vto2201f-p',
    manufacturer: 'Dahua',
    model: 'VTO2201F-P',
    category: 'intercom',
    tagline: 'VTO2201F-P — outdoor IP intercom station, 2 MP, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Video-Intercoms/IP-Series/Villa-Door-Station/Pro-Series/VTO2201F-P',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
      accessControl: ['mifare'],
    },
  },
  {
    id: 'hanwha-tid-600r',
    manufacturer: 'Hanwha',
    model: 'TID-600R',
    category: 'intercom',
    tagline: 'TID-600R — outdoor IP intercom station, 2 MP, IP65',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/camera/network/intercom/tid-600r/',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: true,
    },
  },
  {
    id: 'eufy-video-doorbell-e340-expertsecure-system',
    manufacturer: 'Eufy',
    model: 'VIDEO-DOORBELL-E340-EXPERTSECURE-SYSTEM',
    category: 'intercom',
    tagline: 'VIDEO-DOORBELL-E340-EXPERTSECURE-SYSTEM — indoor IP monitor, ?"',
    verified: true,
    datasheetUrl: 'https://www.eufy.com/products/video-doorbell-e340-expertsecure-system',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: false,
    },
  },
  {
    id: 'eufy-video-doorbell-e340-rechargeable-battery-pack-with-usb-c',
    manufacturer: 'Eufy',
    model: 'VIDEO-DOORBELL-E340-RECHARGEABLE-BATTERY-PACK-WITH-USB-C',
    category: 'intercom',
    tagline: 'VIDEO-DOORBELL-E340-RECHARGEABLE-BATTERY-PACK-WITH-USB-C — indoor IP monitor, ?"',
    verified: true,
    datasheetUrl: 'https://www.eufy.com/products/video-doorbell-e340-expertsecure-system',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: false,
    },
  },
  {
    id: 'eufy-video-doorbell-e340-and-add-on-chime',
    manufacturer: 'Eufy',
    model: 'VIDEO-DOORBELL-E340-AND-ADD-ON-CHIME',
    category: 'intercom',
    tagline: 'VIDEO-DOORBELL-E340-AND-ADD-ON-CHIME — indoor IP monitor, ?"',
    verified: true,
    datasheetUrl: 'https://www.eufy.com/products/video-doorbell-e340-expertsecure-system',
    specs: {
      type: 'ip-proprietary',
      side: 'indoor-monitor',
      cameraMP: 2,
      callButtons: 1,
      ipRating: 'IP65',
      poe: false,
    },
  },
  {
    id: 'lorex-video-doorbell-wedge-kit-for-lnwdb1',
    manufacturer: 'Lorex',
    model: 'VIDEO-DOORBELL-WEDGE-KIT-FOR-LNWDB1',
    category: 'intercom',
    tagline: 'VIDEO-DOORBELL-WEDGE-KIT-FOR-LNWDB1 — outdoor IP intercom station, ? MP',
    verified: true,
    datasheetUrl: 'https://www.lorex.com/products/video-doorbell-wedge-kit-for-lnwdb1',
    specs: {
      type: 'ip-proprietary',
      side: 'outdoor-station',
    },
  },
];
